<template>
    <v-card outlined class="my-5 mx-1">
      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title class="headline compress">
            <span class="clr-grey compress">{{ title }}</span>
          </v-list-item-title>
          <v-list-item-subtitle>
            <span class="clr-grey">{{ subtitle }}</span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-card-text>
        <v-row dense>
          <v-col cols="2" class="text-left">
            <v-icon :color="iconcolor" size="48">{{ icon }}</v-icon>
          </v-col>
          <v-col class="display-1 text-right" cols="10">
            <span :style="`color:${colors}`">{{ statvalue }}</span>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
</template>

<script>
export default {
  name: 'CoreIconCardStat',
  props: {
    icon: {
      type: String,
      required: true
    },
    iconcolor: {
      type: String,
      required: false,
      default: '#cccccc'
    },
    statvalue: {
      type: String,
      required: true
    },
    statcolor: {
      type: String,
      required: false,
      default: '#555555'
    },
    subtitle: {
      type: String,
      required: false,
      default: undefined
    },
    title: {
      type: String,
      required: true
    }
  },
  computed: { 
    colors() {
      if (this.statcolor == 'primary')   return "#335b98"
      if (this.statcolor == 'secondary') return "#29B6F6"
      if (this.statcolor == 'error')     return "#f44336"
      if (this.statcolor == 'warning')   return "#ff9800"
      if (this.statcolor == 'info')      return "#03a9f4"
      if (this.statcolor == 'success')   return "#4caf50"
      return this.statcolor
    }
  }
}
</script>
<style lang="scss" scoped>
.v-card__stats {
  display: flex;
  flex-wrap: wrap;
  position: relative;
}
.clr-grey {
  color: #73879C !important;
}
</style>
